// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3WQgw","boxTitle":"Qualiphy_boxTitle__326nb","box":"Qualiphy_box__14moU","toggleWrap":"Qualiphy_toggleWrap__13DAt"};